"use client";

import Flex from "@/shared/components/common/Flex";
import List from "@/shared/components/common/List";
import { usePagination } from "@/shared/hooks/usePagination";
import type { Hotel } from "@/types/services/hotel/apis/Availability";
import { memo, useRef } from "react";
import HotelCard from "./hotelCard";
import type { Accommodation } from "@/types/services/hotel/apis/Accommodations";
import staticData from "@/public/data/hotel/results.json";
import NoResult from "@/containers/components/NoResult";
import noResultImage from "@/public/svg/noResult.svg";

interface HotelListProps {
  searchParams: SearchParams;
  slugs: {
    city: string;
    star?: number;
  };
  hotels: (Hotel | Accommodation)[];
  device: DeviceType;
}

export default memo(function HotelList({
  hotels = [],
  searchParams,
  slugs,
  device,
}: HotelListProps) {
  const ref = useRef(null);

  const { noResult } = staticData.body;

  const paginatedHotels = usePagination<Hotel>(hotels, ref, null, {
    pageLimit: device === "mobile" ? 2 : 4,
    debounce: 500,
  });

  const noResults = hotels.every((hotel) => !hotel.min_price);

  return (
    <Flex direction={"col"} gap={"3"}>
      {/* - * - * - * - Offered Hotels - * - * - */}
      {noResults && (
        <NoResult
          title={`${noResult.title.suffix} ${slugs.city} ${noResult.title.postfix}`}
          image={noResultImage}
        />
      )}

      <List
        items={paginatedHotels}
        renderItems={(hotel, index) => (
          <HotelCard
            hotel={hotel}
            index={index}
            searchParams={searchParams}
            deviceType={device}
          />
        )}
      />

      <div ref={ref} />
    </Flex>
  );
});
